import React from 'react'
import { useField } from 'formik'

import { InputContainer, Switch } from './styles'

export default function ({
    label, withoutForm, className = '', ...props 
}) {
    let field
    let meta

    if(!props.id && !props.name) {
        throw new Error('Switches must have the "id" or "name" attribute.')
    }

    if(!withoutForm) {
        [field, meta] = useField(props)
    }

    const id = props.id || props.name
    
    if(withoutForm) {
        return (
            <InputContainer>
                <Switch id={id} {...props} />
                <label htmlFor={id}><span /></label>
                <span>{label}</span>
            </InputContainer>
        )
    }

    return (
        <div className={`checkbox-container ${className}`}>
            <InputContainer>
                <Switch id={id} {...field} {...props} checked={field.value} />
                <label htmlFor={id}><span /></label>
                <span>{label}</span>
            </InputContainer>

            {meta.touched && meta.error 
                ? <span className="error">{meta.error}</span>
                : null}
        </div>
    )
}
